function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoupleUserSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    height: "20px",
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 6.746094 11.230469 C 9.265625 11.230469 11.3125 9.179688 11.3125 6.660156 C 11.3125 4.140625 9.265625 2.09375 6.746094 2.09375 C 4.226562 2.09375 2.175781 4.140625 2.175781 6.660156 C 2.175781 9.179688 4.226562 11.230469 6.746094 11.230469 Z M 6.746094 11.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 17.253906 11.230469 C 19.773438 11.230469 21.824219 9.179688 21.824219 6.660156 C 21.824219 4.140625 19.773438 2.09375 17.253906 2.09375 C 14.734375 2.09375 12.6875 4.140625 12.6875 6.660156 C 12.6875 9.179688 14.734375 11.230469 17.253906 11.230469 Z M 17.253906 11.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 6.746094 12.03125 C 3.027344 12.03125 0 15.054688 0 18.773438 L 0 21.0625 C 0 21.527344 0.378906 21.90625 0.847656 21.90625 L 12.644531 21.90625 C 13.109375 21.90625 13.488281 21.527344 13.488281 21.0625 L 13.488281 18.773438 C 13.488281 15.09375 10.523438 12.03125 6.746094 12.03125 Z M 6.746094 12.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 12.996094 13.539062 C 12.878906 13.636719 12.859375 13.8125 12.953125 13.929688 C 14.886719 16.394531 14.617188 18.773438 14.617188 21.0625 C 14.617188 21.234375 14.597656 21.398438 14.554688 21.558594 C 14.507812 21.734375 14.644531 21.90625 14.828125 21.90625 L 23.152344 21.90625 C 23.621094 21.90625 24 21.527344 24 21.0625 L 24 18.773438 C 24 13.039062 17.308594 10.003906 12.996094 13.539062 Z M 12.996094 13.539062 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupleUserSvgrepoCom);
export default __webpack_public_path__ + "static/media/couple-user-svgrepo-com.ddcda5f0.svg";
export { ForwardRef as ReactComponent };